import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
export function applyEventTriggersToFlow(filterBranch, draftFlow) {
  if (filterBranch === null || isFilterEmpty(filterBranch)) {
    draftFlow.shouldReenroll = false;
    draftFlow.enrollmentCriteria = null;
    draftFlow.enrollmentTrigger = null;
  } else {
    draftFlow.enrollmentCriteria = {
      triggerType: 'EVENT',
      triggers: filterBranch
    };
    draftFlow.enrollmentTrigger = 'EVENT';
  }
}
export function applyListTriggersToFlow(filterBranch, draftFlow) {
  if (filterBranch === null) {
    draftFlow.shouldReenroll = false;
    draftFlow.associatedLists = [];
    draftFlow.enrollmentCriteria = null;
    draftFlow.enrollmentTrigger = null;
  } else {
    draftFlow.associatedLists = [{
      filterBranch,
      listTypes: ['ENROLLMENT_LIST']
    }];
    draftFlow.enrollmentCriteria = {
      triggerType: 'LIST',
      filterBranch,
      reEnrollmentTriggers: []
    };
    draftFlow.enrollmentTrigger = 'LIST';
  }
}
export function applyScheduledTriggersToFlow(enrollmentSchedule, draftFlow) {
  if (enrollmentSchedule === null) {
    draftFlow.enrollmentSchedule = null;
    draftFlow.shouldReenroll = false;
    draftFlow.enrollmentTrigger = null;
  } else if (draftFlow.objectTypeId === UNKNOWN_ID) {
    draftFlow.enrollmentSchedule = enrollmentSchedule;
    draftFlow.shouldReenroll = true;
    draftFlow.enrollmentTrigger = 'NEW';
    draftFlow.enrolledType = {
      type: 'VOID'
    };
  } else {
    draftFlow.enrollmentSchedule = enrollmentSchedule;
    draftFlow.shouldReenroll = true;
    draftFlow.enrollmentTrigger = 'LIST';
    draftFlow.enrolledType = {
      type: 'CRM_OBJECT',
      objectTypeId: draftFlow.objectTypeId
    };
  }
}
export function applyManualTriggersToFlow(draftFlow) {
  draftFlow.enrollmentTrigger = 'NEW';
}
export function removeManualTriggersFromFlow(draftFlow) {
  draftFlow.enrollmentTrigger = null;
}